// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    },
  	label: {
      suggestion: {
        placeholder: "Rechercher"
      }
    }
  	
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
  //console.log(this.getLabel('label', 'search_result_header', 'Search Results for ""'));
};
